"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FullTag = FullTag;
exports.StatusTag = StatusTag;
exports.rsStatusOption = exports.rsStatusMultiSelectOption = exports.rsTagMultiSelectOption = exports.rsMultiSelectOption = exports.rsStatusMultiValueLabel = exports.rsStatusSingleValue = exports.rsTagMultiValueLabel = exports.rsMultiValueContainer = exports.rsSelect = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSelect = require("react-select");

var _lodash = require("lodash");

var _ = require("../");

var _contrast_color = require("../utils/contrast_color");

var _color = require("../from-dictionary/color");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject23() {
  var data = _taggedTemplateLiteral(["w-max-300"]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral(["f f-a-center f-gap font-weight-normal"]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["p-x"]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["w-max-300"]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["--check --checked:", ""]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["f f-a-center f-gap font-weight-normal"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["p-left"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["w-max-300"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["--check --checked:", ""]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["f f-a-center f-gap font-weight-normal"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["p-left"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["ellipsis"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["--check --checked:", ""]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["f f-a-center f-gap font-weight-normal"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["p-left"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["border-1-s-transparent"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["m-x-small"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _templateObject6() {
  var data = _taggedTemplateLiteral(["f-1-1-auto ellipsis"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["w-max-100%"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["#", ""]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _templateObject3() {
  var data = _taggedTemplateLiteral(["f-1-1-auto ellipsis color-default"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["w-max-100%"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["--tag"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var statusColors = {
  'completed': '--status-completed',
  'someDisruption': '--status-minor-disruption',
  'minorDisruption': '--status-minor-disruption',
  'majorDisruption': '--status-major-disruption',
  'onTrack': '--status-on-track',
  'upcoming': '--status-upcoming',
  'statusPending': '--status-pending',
  'discontinued': '--status-discontinued'
};

function FullTag(props) {
  var name = props.name,
      color = props.color,
      addClass = props.addClass;
  return /*#__PURE__*/_react.default.createElement("span", _extends({}, (0, _.ui)([(0, _.uiBadge)(_templateObject()), (0, _.uiA)(_templateObject2()), addClass]), {
    style: {
      color: color
    }
  }), /*#__PURE__*/_react.default.createElement("span", _extends({}, (0, _.ui)([(0, _.uiA)(_templateObject3())]), {
    style: {
      height: '1.1em'
    }
  }), name));
}

function StatusTag(props) {
  var value = props.value,
      name = props.name,
      addClass = props.addClass;
  return /*#__PURE__*/_react.default.createElement("span", (0, _.ui)([(0, _.uiBadge)(_templateObject4(), statusColors[value]), (0, _.uiA)(_templateObject5()), addClass]), /*#__PURE__*/_react.default.createElement("span", (0, _.ui)([(0, _.uiA)(_templateObject6())]), name));
}

FullTag.propTypes = {
  name: _propTypes.default.string.isRequired,
  color: _propTypes.default.string.isRequired,
  addClass: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.string])
};
FullTag.defaultProps = {
  addClass: ''
};

var rsSelect = function rsSelect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$showError = _ref.showError,
      showError = _ref$showError === void 0 ? false : _ref$showError,
      _ref$reflowMultiSelec = _ref.reflowMultiSelect,
      reflowMultiSelect = _ref$reflowMultiSelec === void 0 ? false : _ref$reflowMultiSelec,
      _ref$tagStyle = _ref.tagStyle,
      tagStyle = _ref$tagStyle === void 0 ? false : _ref$tagStyle,
      _ref$statusStyle = _ref.statusStyle,
      statusStyle = _ref$statusStyle === void 0 ? false : _ref$statusStyle,
      _ref$stackLeft = _ref.stackLeft,
      stackLeft = _ref$stackLeft === void 0 ? false : _ref$stackLeft,
      _ref$stackRight = _ref.stackRight,
      stackRight = _ref$stackRight === void 0 ? false : _ref$stackRight,
      _ref$udjustedLabelLen = _ref.udjustedLabelLength,
      udjustedLabelLength = _ref$udjustedLabelLen === void 0 ? 0 : _ref$udjustedLabelLen;

  return {
    styles: {
      menu: function menu(provided) {
        return _objectSpread(_objectSpread({}, provided), {}, {
          width: 'auto',
          minWidth: '100%',
          position: 'absolute',
          display: 'flex',
          marginTop: '2px',
          marginBottom: '2px',
          padding: '0',
          // right: '0',
          border: '1px solid #d1d4e4',
          borderRadius: 3,
          backgroundColor: '#ffffff',
          boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.1)'
        });
      },
      indicatorSeparator: function indicatorSeparator(provided) {
        return _objectSpread(_objectSpread({}, provided), {}, {
          marginTop: '4px',
          marginBottom: '4px',
          height: reflowMultiSelect ? 'auto' : '25px',
          //this
          color: "".concat(_color.UI_COLOR_PLAIN_GRAY)
        });
      },
      menuList: function menuList(provided) {
        return _objectSpread(_objectSpread({}, provided), {}, {
          width: '100%'
        });
      },
      indicatorContainer: function indicatorContainer(provided) {
        return _objectSpread(_objectSpread({}, provided), {}, {
          marginTop: '0',
          marginBottom: '0',
          height: '33px'
        });
      },
      clearIndicator: function clearIndicator(provided) {
        return _objectSpread(_objectSpread({}, provided), {}, {
          padding: '4px'
        });
      },
      valueContainer: function valueContainer(provided) {
        return _objectSpread(_objectSpread({}, provided), {}, {
          height: reflowMultiSelect ? 'auto' : '33px',
          minHeight: '33px',
          flexWrap: reflowMultiSelect ? 'wrap' : 'nowrap' // border: '0',
          // maxWidth: '0',
          // padding: '0',
          // opacity: '0',

        });
      },
      control: function control(provided, _ref2) {
        var isDisabled = _ref2.isDisabled,
            isFocused = _ref2.isFocused;
        return _objectSpread(_objectSpread({}, provided), {}, {
          borderWidth: '1px',
          borderStyle: 'solid',
          borderColor: showError ? "".concat(_color.UI_COLOR_RED, " !important") : isFocused ? '#76bcd0 !important' : "".concat(_color.UI_COLOR_PLAIN_GRAY),
          borderRadius: '3px',
          borderTopLeftRadius: stackRight ? '0' : '3px',
          borderBottomLeftRadius: stackRight ? '0' : '3px',
          borderTopRightRadius: stackLeft ? '0' : '3px',
          borderBottomRightRadius: stackLeft ? '0' : '3px',
          borderRightWidth: stackLeft ? '0' : '1px',
          // padding: '0 10px',
          boxShadow: isFocused ? "inset 0 0 1px 3px rgba(".concat(showError ? '204, 24, 30, 0.2' : '118,188,208,0.3', ")") : '0',
          minHeight: '35px',
          maxHeight: reflowMultiSelect ? 'auto' : '35px' // backgroundColor: 'transparent',

        });
      },
      dropdownIndicator: function dropdownIndicator(provided) {
        return _objectSpread(_objectSpread({}, provided), {}, {
          width: '15px',
          marginLeft: '6px',
          marginRight: '6px',
          padding: '0'
        });
      },
      // menuList: (provided) => ({
      //   ...provided,
      //   display: 'flex',
      //   flexDirection: 'column',
      //   margin: '0',
      //   padding: '0',
      //   overflow: 'hidden',
      // }),
      option: function option(provided, _ref3) {
        var isDisabled = _ref3.isDisabled,
            isFocused = _ref3.isFocused,
            isSelected = _ref3.isSelected;
        return _objectSpread(_objectSpread({}, provided), {}, {
          cursor: isDisabled ? 'default' : 'pointer',
          color: _color.UI_COLOR_DEFAULT,
          paddingRight: '25px',
          whiteSpace: 'nowrap',
          flexWrap: 'nowrap'
        });
      },
      multiValueContainer: function multiValueContainer(provided) {
        return _objectSpread(_objectSpread({}, provided), {}, {
          flexWrap: 'nowrap'
        });
      },
      multiValueLabel: function multiValueLabel(provided) {
        return _objectSpread(_objectSpread({}, provided), tagStyle || statusStyle ? {
          padding: '0',
          paddingLeft: '0'
        } : {});
      },
      multiValue: function multiValue(provided, _ref4) {
        var _getValue;

        var getValue = _ref4.getValue,
            hasValue = _ref4.hasValue,
            isMulti = _ref4.isMulti;
        return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, provided), tagStyle || statusStyle ? {
          minWidth: '50px',
          maxWidth: '175px'
        } : {}), tagStyle ? {
          borderRadius: '3px',
          border: "1px solid ".concat(_color.UI_COLOR_PLAIN_GRAY),
          backgroundColor: "".concat(_color.UI_COLOR_WHITE)
        } : {}), udjustedLabelLength && isMulti && hasValue ? {
          maxWidth: "".concat(udjustedLabelLength / ((_getValue = getValue()) === null || _getValue === void 0 ? void 0 : _getValue.length), "px")
        } : {});
      },
      multiValueRemove: function multiValueRemove(provided) {
        return _objectSpread(_objectSpread(_objectSpread({}, provided), tagStyle || statusStyle ? {
          flex: '0 0 auto'
        } : {}), tagStyle ? {
          // borderRadius: '50%',
          borderTopLeftRadius: '0',
          borderBottomLeftRadius: '0',
          borderLeft: "1px dotted ".concat(_color.UI_COLOR_PLAIN_GRAY),
          color: "".concat(_color.UI_COLOR_PLAIN_GRAY),
          '&:hover': {
            cursor: 'pointer'
          }
        } : {});
      }
    },
    components: {
      // IndicatorSeparator: () => null,
      // Placeholder: () => null,
      // SingleValue: () => null,
      SingleValue: function SingleValue() {
        return null;
      }
    },
    theme: function theme(_theme) {
      return _objectSpread(_objectSpread({}, _theme), {}, {
        borderRadius: 3,
        colors: _objectSpread(_objectSpread({}, _theme.colors), {}, {
          primary25: _color.UI_COLOR_PALE_BLUE,
          primary: '#b2d4ff'
        })
      });
    }
  };
};

exports.rsSelect = rsSelect;

var rsMultiValueContainer = function rsMultiValueContainer(_ref5) {
  var children = _ref5.children,
      maxValuesToShow = _ref5.selectProps.maxValuesToShow,
      props = _objectWithoutProperties(_ref5, ["children", "selectProps"]);

  var getValue = props.getValue,
      hasValue = props.hasValue;
  var valuesCount = getValue().length;

  if (!hasValue) {
    return /*#__PURE__*/_react.default.createElement(_reactSelect.components.ValueContainer, props, children);
  }

  return /*#__PURE__*/_react.default.createElement(_reactSelect.components.ValueContainer, props, (0, _lodash.take)(children[0], maxValuesToShow), valuesCount > maxValuesToShow ? /*#__PURE__*/_react.default.createElement("span", (0, _.ui)([(0, _.uiA)(_templateObject7())]), "+".concat(valuesCount - maxValuesToShow)) : '', children[1]);
};

exports.rsMultiValueContainer = rsMultiValueContainer;

var rsTagMultiValueLabel = function rsTagMultiValueLabel(_ref6) {
  var _ref6$data = _ref6.data,
      label = _ref6$data.label,
      color = _ref6$data.color,
      data = _objectWithoutProperties(_ref6$data, ["label", "color"]),
      props = _objectWithoutProperties(_ref6, ["data"]);

  return /*#__PURE__*/_react.default.createElement(_reactSelect.components.MultiValueLabel, _extends({
    data: _objectSpread({
      label: label,
      color: color
    }, data)
  }, props), /*#__PURE__*/_react.default.createElement(FullTag, {
    name: label,
    color: color,
    addClass: (0, _.uiMerge)([(0, _.uiA)(_templateObject8())])
  }));
};

exports.rsTagMultiValueLabel = rsTagMultiValueLabel;

var rsStatusSingleValue = function rsStatusSingleValue(_ref7) {
  var _ref7$data = _ref7.data,
      value = _ref7$data.value,
      label = _ref7$data.label,
      data = _objectWithoutProperties(_ref7$data, ["value", "label"]),
      props = _objectWithoutProperties(_ref7, ["data"]);

  return /*#__PURE__*/_react.default.createElement(_reactSelect.components.SingleValue, _extends({
    data: _objectSpread({
      label: label,
      value: value
    }, data)
  }, props), /*#__PURE__*/_react.default.createElement(StatusTag, {
    value: value,
    name: label
  }));
};

exports.rsStatusSingleValue = rsStatusSingleValue;

var rsStatusMultiValueLabel = function rsStatusMultiValueLabel(_ref8) {
  var _ref8$data = _ref8.data,
      value = _ref8$data.value,
      label = _ref8$data.label,
      data = _objectWithoutProperties(_ref8$data, ["value", "label"]),
      props = _objectWithoutProperties(_ref8, ["data"]);

  return /*#__PURE__*/_react.default.createElement(_reactSelect.components.MultiValueLabel, _extends({
    data: _objectSpread({
      label: label,
      value: value
    }, data)
  }, props), /*#__PURE__*/_react.default.createElement(StatusTag, {
    value: value,
    name: label
  }));
};

exports.rsStatusMultiValueLabel = rsStatusMultiValueLabel;

var rsMultiSelectOption = function rsMultiSelectOption(props) {
  var isSelected = props.isSelected,
      reducedProps = _objectWithoutProperties(props, ["isSelected"]);

  return /*#__PURE__*/_react.default.createElement(_reactSelect.components.Option, _extends({}, reducedProps, (0, _.ui)([(0, _.uiA)(_templateObject9())])), /*#__PURE__*/_react.default.createElement("span", (0, _.ui)([(0, _.uiA)(_templateObject10())]), /*#__PURE__*/_react.default.createElement("span", (0, _.ui)([(0, _.uiCheckbox)(_templateObject11(), isSelected)])), /*#__PURE__*/_react.default.createElement("span", (0, _.ui)([(0, _.uiA)(_templateObject12())]), reducedProps === null || reducedProps === void 0 ? void 0 : reducedProps.label)));
};

exports.rsMultiSelectOption = rsMultiSelectOption;

var rsTagMultiSelectOption = function rsTagMultiSelectOption(_ref9) {
  var isSelected = _ref9.isSelected,
      label = _ref9.label,
      _ref9$data = _ref9.data,
      color = _ref9$data.color,
      data = _objectWithoutProperties(_ref9$data, ["color"]),
      props = _objectWithoutProperties(_ref9, ["isSelected", "label", "data"]);

  return /*#__PURE__*/_react.default.createElement(_reactSelect.components.Option, _extends({
    label: label,
    data: _objectSpread(_objectSpread({}, data), {}, {
      color: color
    })
  }, props, (0, _.ui)([(0, _.uiA)(_templateObject13())])), /*#__PURE__*/_react.default.createElement("span", (0, _.ui)([(0, _.uiA)(_templateObject14())]), /*#__PURE__*/_react.default.createElement("span", (0, _.ui)([(0, _.uiCheckbox)(_templateObject15(), isSelected)])), /*#__PURE__*/_react.default.createElement(FullTag, {
    name: label,
    color: color,
    addClass: (0, _.uiA)(_templateObject16())
  })));
};

exports.rsTagMultiSelectOption = rsTagMultiSelectOption;

var rsStatusMultiSelectOption = function rsStatusMultiSelectOption(_ref10) {
  var isSelected = _ref10.isSelected,
      label = _ref10.label,
      value = _ref10.value,
      data = _extends({}, _ref10.data),
      props = _objectWithoutProperties(_ref10, ["isSelected", "label", "value", "data"]);

  return /*#__PURE__*/_react.default.createElement(_reactSelect.components.Option, _extends({
    label: label,
    value: value,
    data: _objectSpread({}, data)
  }, props, (0, _.ui)([(0, _.uiA)(_templateObject17())])), /*#__PURE__*/_react.default.createElement("span", (0, _.ui)([(0, _.uiA)(_templateObject18())]), /*#__PURE__*/_react.default.createElement("span", (0, _.ui)([(0, _.uiCheckbox)(_templateObject19(), isSelected)])), /*#__PURE__*/_react.default.createElement(StatusTag, {
    name: label,
    value: value,
    addClass: (0, _.uiA)(_templateObject20())
  })));
};

exports.rsStatusMultiSelectOption = rsStatusMultiSelectOption;

var rsStatusOption = function rsStatusOption(_ref11) {
  var isSelected = _ref11.isSelected,
      label = _ref11.label,
      value = _ref11.value,
      data = _extends({}, _ref11.data),
      props = _objectWithoutProperties(_ref11, ["isSelected", "label", "value", "data"]);

  return /*#__PURE__*/_react.default.createElement(_reactSelect.components.Option, _extends({
    label: label,
    value: value,
    data: _objectSpread({}, data)
  }, props, (0, _.ui)([(0, _.uiA)(_templateObject21())])), /*#__PURE__*/_react.default.createElement("span", (0, _.ui)([(0, _.uiA)(_templateObject22())]), /*#__PURE__*/_react.default.createElement(StatusTag, {
    name: label,
    value: value,
    addClass: (0, _.uiA)(_templateObject23())
  })));
}; // export const rsSelectPlus = ({ showError }) => ({
//   styles: {
//     ...rsSelect.styles,
//     control: (provided, {isDisabled, isFocused}) => ({
//       ...provided,
//       borderWidth: '1px',
//       borderStyle: 'solid',
//       borderColor: showError ? 'red' : (isFocused ? '#76bcd0 !important' : UI_COLOR_PLAIN_GRAY),
//       borderRadius: '3px',
//       // padding: '0 10px',
//       boxShadow: isFocused ? `inset 0 0 1px 3px rgba(${showError ? '118,188,008,0.3' : '118,188,208,0.3'})` : '0',
//       minHeight: '35px',
//       maxHeight: '35px',
//       // backgroundColor: 'transparent',
//     }),
//   },
//   theme : {
//     ...rsSelect.theme,
//   },
// });


exports.rsStatusOption = rsStatusOption;